import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.nodes.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-nodes-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.nodes.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraNodesItemComponent implements OnInit, OnDestroy {
    public item: any = null;
    public id: number = 0;
    public tab: string = 'summary';
    public deleting: boolean = false;
    public tabs: any[] = [];
    public logPolicy: any = { node_history: true, node_timeline: true };
    private routerSub: Subscription;
    private langSub: Subscription;
    public heartbeatStatus: any = {
        state: 'none',
        label: 'No heartbeat',
        detail: '',
    };
    public provisioningSignal: any = null;
    public operationStatuses: any[] = [];
    public summaryCards: any[] = [];
    public hardwareComputeCards: any[] = [];
    public hardwareAssetCards: any[] = [];
    public copiedHardwareKey: string = '';
    public bmcCredentialProfiles: any[] = [];
    public selectedCredentialId: any = '';
    public bmcTestLoading: boolean = false;
    public bmcTestResult: any = null;
    public bmcRecheckLoading: boolean = false;
    public bmcRecheckMessage: string = '';
    private bmcTestRequestId: number = 0;
    private componentDestroyed: boolean = false;

    // Network tab
    public networkList: any[] = [];
    public editingNetwork: any = null;
    public networkTypes: string[] = ['ethernet', 'infiniband', 'bond', 'vlan'];
    public networkModes: Array<{ value: string; label: string; }> = [
        { value: 'dhcp', label: 'DHCP' },
        { value: 'static', label: 'Static' },
        { value: 'unconfigured', label: 'Unconfigured' },
    ];

    // Storage tab
    public storageList: any[] = [];
    public editingStorage: any = null;
    public fsTypes: string[] = ['ext4', 'xfs', 'btrfs', 'ntfs', 'swap', 'zfs', ''];

    // Devices tab
    public deviceList: any[] = [];

    // History tab
    public deployHistory: any[] = [];
    public historySortField: string = 'id';
    public historySortDir: string = 'desc';
    public historySearchText: string = '';
    public historyStatusFilter: string = 'all';
    public historyMethodFilter: string = 'all';
    public historyStatusOptions: string[] = ['all'];
    public historyMethodOptions: string[] = ['all'];
    public historyPage: number = 1;
    public historyPageSize: number = 30;
    public historyTotalCount: number = 0;
    public historyPageSizeOptions: number[] = [30, 50, 100];

    // Timeline tab
    public timelineEvents: any[] = [];
    public timelineSummary: any = {};
    public timelineFilter: string = 'all';
    public timelineSearchText: string = '';
    public timelineStatusFilter: string = 'all';
    public timelineStatusOptions: string[] = ['all'];
    public timelineRange: string = '30';  // '7', '30', 'all'
    public timelineChart: any[] = [];  // [{label, deploy, commission, pxe, total}]
    public timelinePage: number = 1;
    public timelinePageSize: number = 10;
    public timelineTotalCount: number = 0;
    public timelinePageSizeOptions: number[] = [10, 30, 50, 100];
    public readonly timelinePageWindowSize: number = 10;
    public timelineExpandedGroups: any = {};

    // Groups for dropdown
    public groups: any[] = [];

    // Zabbix tab
    public zabbixStatus: any = null;
    public zabbixLoading: boolean = false;
    public zabbixInstallLog: string = '';
    public sshUser: string = 'root';
    public sshPassword: string = 'kiera123';
    public zabbixServerIp: string = '';
    public proxyName: string = '';
    public zabbixConnectMode: string = 'direct';
    private zabbixConfigLoaded: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( TranslateService)  private translate: TranslateService) {
        this.setHeartbeatStatus('none', 'page.nodes.item.heartbeat.none_label', 'page.nodes.item.heartbeat.none_detail');
    }

    public async ngOnInit() {
        await this.service.init();
        this.buildTabs();
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'summary';
        const groupsPromise = this.loadGroups().catch((error: any) => console.error(error));
        await this.load();
        await groupsPromise;
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newTab = WizRoute.segment.tab || 'summary';
                const nextTab = this.isTabEnabled(newTab) ? newTab : 'summary';
                if (nextTab !== newTab) {
                    this.service.href(`/kiera/nodes/${this.id}/summary`);
                    return;
                }
                if (nextTab !== this.tab) {
                    this.tab = nextTab;
                    await this.loadTabData();
                    await this.service.render();
                }
            }
        });

        this.langSub = this.translate.onLangChange.subscribe(() => {
            this.buildTabs();
            if (this.item) {
                this.updateProvisioningIndicators();
                this.refreshSummaryView();
            }
            this.service.render();
        });
    }

    private buildTabs() {
        this.tabs = [
            { key: 'summary', label: this.translate.instant('page.nodes.item.tab.summary'), icon: 'bx bx-info-circle' },
            { key: 'network', label: this.translate.instant('page.nodes.item.tab.network'), icon: 'bx bx-network-chart' },
            { key: 'storage', label: this.translate.instant('page.nodes.item.tab.storage'), icon: 'bx bx-hdd' },
            { key: 'devices', label: this.translate.instant('page.nodes.item.tab.devices'), icon: 'bx bx-microchip' },
            { key: 'zabbix', label: this.translate.instant('page.nodes.item.tab.zabbix'), icon: 'bx bx-bar-chart-alt-2' },
        ];
        if (this.canManageResourceUsers()) this.tabs.push({ key: 'users', label: this.translate.instant('resource_access.users_tab'), icon: 'bx bx-user-check' });
        if (this.logPolicy?.node_history !== false) {
            this.tabs.splice(4, 0, { key: 'history', label: this.translate.instant('page.nodes.item.tab.history'), icon: 'bx bx-history' });
        }
        if (this.logPolicy?.node_timeline !== false) {
            const insertAt = this.logPolicy?.node_history === false ? 4 : 5;
            this.tabs.splice(insertAt, 0, { key: 'timeline', label: this.translate.instant('page.nodes.item.tab.timeline'), icon: 'bx bx-git-commit' });
        }
    }

    ngOnDestroy() {
        this.componentDestroyed = true;
        this.bmcTestRequestId += 1;
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.langSub) this.langSub.unsubscribe();
    }

    public async loadGroups() {
        const { code, data } = await wiz.call("groups");
        if (code === 200) {
            this.groups = data;
        }
    }

    public async load() {
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href('/kiera/nodes');
            return;
        }
        this.item = data;
        this.logPolicy = {
            node_history: data?.log_policy?.node_history !== false,
            node_timeline: data?.log_policy?.node_timeline !== false,
        };
        this.buildTabs();
        if (!this.isTabEnabled(this.tab)) {
            this.tab = 'summary';
            this.service.href(`/kiera/nodes/${this.id}/summary`);
        }
        this.applyDefaultSshUser();
        this.configureBmcCredentialProfiles(data);
        this.updateProvisioningIndicators();
        this.refreshSummaryView();
        await this.loadTabData();
        await this.service.render();
    }

    private parseTimestamp(value: any): Date | null {
        const text = String(value || '').trim();
        if (!text) return null;
        const parsed = new Date(text.replace(' ', 'T'));
        if (Number.isNaN(parsed.getTime())) return null;
        return parsed;
    }

    private translateText(key: string, params: any = {}) {
        return this.translate.instant(key, params);
    }

    private setHeartbeatStatus(state: string, labelKey: string, detailKey: string, params: any = {}) {
        this.heartbeatStatus = {
            state,
            label: this.translateText(labelKey, params),
            detail: this.translateText(detailKey, params),
        };
    }

    private setProvisioningSignal(tone: string, titleKey: string, detailKey: string, params: any = {}) {
        this.provisioningSignal = {
            tone,
            title: this.translateText(titleKey, params),
            detail: this.translateText(detailKey, params),
        };
    }

    private updateProvisioningIndicators() {
        const lastCheckinText = String(this.item?.last_checkin || '').trim();
        const lastCheckin = this.parseTimestamp(lastCheckinText);
        const hasIp = Boolean(String(this.item?.ip_address || '').trim());
        const deployStatus = String(this.item?.deploy_status || '').toLowerCase();
        const nodeStatus = String(this.item?.status || '').toLowerCase();
        const activeProvisioning = ['deploy', 'commission', 'diskless', 'backup'].some((token) => deployStatus.includes(token) || nodeStatus.includes(token));
        const failedProvisioning = deployStatus.includes('failed') || nodeStatus.includes('failed') || nodeStatus.includes('error');

        if (!lastCheckin) {
            this.setHeartbeatStatus('none', 'page.nodes.item.heartbeat.none_label', 'page.nodes.item.heartbeat.none_detail');
        } else {
            const ageMinutes = Math.max(0, Math.floor((Date.now() - lastCheckin.getTime()) / 60000));
            if (ageMinutes <= 15) {
                this.setHeartbeatStatus('recent', 'page.nodes.item.heartbeat.recent_label', 'page.nodes.item.heartbeat.recent_detail', {
                    timestamp: lastCheckinText,
                    minutes: ageMinutes,
                });
            } else {
                this.setHeartbeatStatus('stale', 'page.nodes.item.heartbeat.stale_label', 'page.nodes.item.heartbeat.stale_detail', {
                    timestamp: lastCheckinText,
                });
            }
        }

        if (failedProvisioning) {
            this.setProvisioningSignal('rose', 'page.nodes.item.signal.failed_title', 'page.nodes.item.signal.failed_detail');
            return;
        }

        if (activeProvisioning && !hasIp) {
            this.setProvisioningSignal('amber', 'page.nodes.item.signal.no_ip_title', 'page.nodes.item.signal.no_ip_detail');
            return;
        }

        if (activeProvisioning && this.heartbeatStatus.state === 'none') {
            this.setProvisioningSignal('sky', 'page.nodes.item.signal.no_heartbeat_title', 'page.nodes.item.signal.no_heartbeat_detail');
            return;
        }

        if (this.heartbeatStatus.state === 'recent') {
            this.setProvisioningSignal('emerald', 'page.nodes.item.signal.recent_title', 'page.nodes.item.signal.recent_detail');
            return;
        }

        this.setProvisioningSignal('zinc', 'page.nodes.item.signal.general_title', 'page.nodes.item.signal.general_detail');
    }

    public heartbeatBadgeClass(): string {
        if (this.heartbeatStatus.state === 'recent') return 'bg-emerald-100 text-emerald-700';
        if (this.heartbeatStatus.state === 'stale') return 'bg-amber-100 text-amber-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    private normalizeBmcProtocol(value: any): string {
        const normalized = String(value || '').trim().toLowerCase();
        if (normalized.includes('redfish')) return 'redfish';
        if (normalized.includes('ipmi')) return 'ipmi';
        if (normalized === 'none') return '';
        return normalized;
    }

    private configureBmcCredentialProfiles(data: any) {
        this.bmcCredentialProfiles = Array.isArray(data?.bmc_credential_profiles)
            ? data.bmc_credential_profiles.filter((profile: any) => profile && profile.id !== undefined)
            : [];
        const assignedId = String(data?.bmc_credential_id || '');
        const selected = this.bmcCredentialProfiles.find(
            (profile: any) => String(profile.id) === assignedId
        ) || null;
        this.selectedCredentialId = selected ? selected.id : '';
    }

    public selectedCredentialProfile(): any {
        return this.bmcCredentialProfiles.find(
            (profile: any) => String(profile.id) === String(this.selectedCredentialId)
        ) || null;
    }

    public async selectCredentialProfile(profileId: any) {
        this.selectedCredentialId = profileId;
        const profile = this.selectedCredentialProfile();
        if (this.item) {
            this.item.bmc_credential_id = profile?.id || '';
            this.item.bmc_credential_name = profile?.name || '';
        }
        if (profile && this.item) {
            if (profile.port) this.item.bmc_port = String(profile.port);
            if (profile.username) this.item.bmc_username = profile.username;
            const protocol = this.normalizeBmcProtocol(profile.protocol || profile.bmc_type);
            if (profile.bmc_type) this.item.bmc_type = profile.bmc_type;
            else if (protocol === 'redfish') this.item.bmc_type = 'REDFISH';
            else if (protocol === 'ipmi') this.item.bmc_type = 'IPMI';
        }
        this.refreshSummaryView();
        await this.service.render();
    }

    public credentialTlsLabel(profile: any): string {
        return this.translateText(profile?.tls ? 'page.nodes.item.used' : 'page.nodes.item.not_used');
    }

    public normalizeStatus(value: any, fallback: string = '-'): string {
        const text = String(value || '').trim();
        if (!text) return fallback;
        return text.replace(/_/g, ' ').replace(/\s+/g, ' ').toUpperCase();
    }

    public nodeStatusTone(value: any): string {
        const status = String(value || '').trim().toLowerCase();
        if (status.includes('fail') || status.includes('error')) return 'rose';
        if (status.includes('deploy') || status.includes('progress') || status.includes('commission')) return 'amber';
        if (status.includes('ready') || status.includes('healthy') || status.includes('active')) return 'emerald';
        return 'zinc';
    }

    public bootModeTone(value: any): string {
        const mode = String(value || '').trim().toLowerCase();
        if (mode === 'uefi' || mode === 'efi') return 'indigo';
        if (mode === 'legacy' || mode === 'bios') return 'amber';
        return 'zinc';
    }

    public clusterStatusTone(): string {
        if (!this.item?.cluster_id) return 'zinc';
        return this.nodeStatusTone(this.item?.cluster_status);
    }

    public clusterStatusLabel(): string {
        if (!this.item?.cluster_id) return this.translateText('page.nodes.item.not_assigned');
        const status = String(this.item?.cluster_status || '').trim();
        if (!status) return '-';
        const normalized = status.toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-');
        const key = 'page.nodes.item.cluster_status_value.' + normalized;
        const translated = this.translateText(key);
        return translated === key ? this.normalizeStatus(status) : translated;
    }

    public provisioningModeLabel(): string {
        if (!this.item?.cluster_id) return this.translateText('page.nodes.item.not_assigned');
        const mode = String(this.item?.provisioning_mode || '').trim().toLowerCase();
        if (mode === 'relay') return 'Relay';
        if (mode === 'direct') return 'Direct';
        return mode ? this.normalizeStatus(mode) : '-';
    }

    public summaryStatusBadgeClass(tone: string): string {
        if (tone === 'emerald') return 'bg-emerald-100 text-emerald-700';
        if (tone === 'amber') return 'bg-amber-100 text-amber-700';
        if (tone === 'rose') return 'bg-rose-100 text-rose-700';
        if (tone === 'indigo') return 'bg-indigo-100 text-indigo-700';
        if (tone === 'sky') return 'bg-sky-100 text-sky-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public summaryStatusIconClass(tone: string): string {
        if (tone === 'emerald') return 'bg-emerald-500 text-white';
        if (tone === 'amber') return 'bg-amber-400 text-white';
        if (tone === 'rose') return 'bg-rose-500 text-white';
        if (tone === 'indigo') return 'bg-indigo-500 text-white';
        if (tone === 'sky') return 'bg-sky-500 text-white';
        return 'bg-zinc-300 text-white';
    }

    public showProvisioningNotice(): boolean {
        const tone = String(this.provisioningSignal?.tone || '');
        const deployFailed = String(this.item?.deploy_status || '').toLowerCase().includes('failed');
        if (tone === 'rose' && deployFailed) return false;
        return ['rose', 'amber', 'sky'].includes(tone);
    }

    public provisioningNoticeClass(): string {
        const tone = String(this.provisioningSignal?.tone || '');
        if (tone === 'rose') return 'border-rose-200 bg-rose-50 text-rose-700';
        if (tone === 'amber') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (tone === 'sky') return 'border-sky-200 bg-sky-50 text-sky-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-700';
    }

    private bmcConnectionState(): string {
        if (this.bmcTestLoading) return 'testing';
        if (this.bmcTestResult) {
            if (this.bmcTestResult.ok) return 'connected';
            return String(this.bmcTestResult.status || 'failed').trim().toLowerCase();
        }
        return String(this.item?.bmc_connection_status || 'unregistered').trim().toLowerCase();
    }

    private refreshSummaryView() {
        if (!this.item) {
            this.operationStatuses = [];
            this.summaryCards = [];
            this.hardwareComputeCards = [];
            this.hardwareAssetCards = [];
            return;
        }

        const nodeStatus = this.normalizeStatus(this.item.status, 'NEW');
        const deployStatus = this.normalizeStatus(this.item.deploy_status, '-');
        const agentTone = this.heartbeatStatus.state === 'recent'
            ? 'emerald'
            : this.heartbeatStatus.state === 'stale' ? 'amber' : 'zinc';
        const agentValue = this.heartbeatStatus.state === 'recent'
            ? 'HEALTHY'
            : this.heartbeatStatus.state === 'stale' ? 'STALE' : 'NO HEARTBEAT';
        const bmcState = this.bmcConnectionState();
        const bmcTone = bmcState === 'connected'
            ? 'emerald'
            : bmcState === 'testing' ? 'sky'
            : bmcState === 'configured' || bmcState === 'incomplete' ? 'amber'
            : ['error', 'failed', 'authentication-failed', 'timeout', 'unreachable'].includes(bmcState) ? 'rose'
            : bmcState === 'missing-credential' || bmcState === 'unregistered' ? 'rose' : 'zinc';
        const bmcValueMap: any = {
            testing: 'CHECKING',
            connected: 'CONNECTED',
            configured: 'CONFIGURED',
            incomplete: 'INCOMPLETE',
            error: 'FAILED',
            failed: 'FAILED',
            'authentication-failed': 'AUTH FAILED',
            timeout: 'TIMEOUT',
            unreachable: 'UNREACHABLE',
            'missing-credential': 'BMC FAULT',
            unregistered: 'BMC FAULT',
        };
        const monitoringState = String(this.item.monitoring_status || 'unknown').trim().toLowerCase();
        const monitoringAvailability = String(this.item.monitoring_availability || 'unknown').trim().toLowerCase();
        const monitoringValueMap: any = {
            enabled: 'ENABLED',
            disabled: 'DISABLED',
            'not-deployed': 'NOT DEPLOYED',
            'not-configured': 'NOT CONFIGURED',
            'not-registered': 'NOT REGISTERED',
            unknown: 'UNKNOWN',
        };
        const monitoringTone = monitoringState === 'enabled'
            ? monitoringAvailability === 'available' ? 'emerald'
                : monitoringAvailability === 'unavailable' ? 'rose' : 'amber'
            : monitoringState === 'unknown' ? 'amber' : 'zinc';
        const monitoringDetailState = monitoringState === 'enabled'
            ? `enabled-${monitoringAvailability}`
            : monitoringState;
        const monitoringDetailKey = `page.nodes.item.monitoring_detail.${monitoringDetailState}`;
        const translatedMonitoringDetail = this.translateText(monitoringDetailKey);
        const monitoringDetail = translatedMonitoringDetail === monitoringDetailKey
            ? String(this.item.monitoring_detail || 'Zabbix')
            : translatedMonitoringDetail;
        const bmcMonitorDetail = [
            this.item.bmc_last_error
                ? `${this.bmcErrorReasonLabel(this.item.bmc_last_error_code)}: ${this.item.bmc_last_error}`
                : '',
            this.item.last_bmc_check
                ? this.translateText('page.nodes.item.last_bmc_scan', { timestamp: this.item.last_bmc_check })
                : this.translateText('page.nodes.item.no_scan_history'),
            Number(this.item.bmc_failure_count || 0) > 0
                ? this.translateText('page.nodes.item.bmc_failure_count_value', {
                    count: this.item.bmc_failure_count,
                    threshold: this.item.bmc_failure_threshold || 3,
                })
                : '',
        ].filter(Boolean).join(' · ');
        const bmcDetail = this.bmcTestLoading
            ? this.translateText('page.nodes.item.testing')
            : this.bmcTestResult
                ? [
                    String(this.bmcTestResult.message || ''),
                    this.bmcTestResult.tested_at
                        ? this.translateText('page.nodes.item.last_bmc_test', { timestamp: this.bmcTestResult.tested_at })
                        : '',
                ].filter(Boolean).join(' · ')
                : bmcMonitorDetail;

        this.operationStatuses = [
            {
                label: this.translateText('page.nodes.item.node_status'),
                value: nodeStatus,
                detail: this.translateText('page.nodes.item.deploy_status_detail', { status: deployStatus }),
                tone: this.nodeStatusTone(this.item.status),
                icon: this.nodeStatusTone(this.item.status) === 'rose' ? 'bx bx-x' : 'bx bx-check',
            },
            {
                label: this.translateText('page.nodes.item.agent_status'),
                value: agentValue,
                detail: this.heartbeatStatus.detail || '-',
                tone: agentTone,
                icon: agentTone === 'emerald' ? 'bx bx-check' : 'bx bx-time-five',
            },
            {
                label: this.translateText('page.nodes.item.bmc_connection'),
                value: bmcValueMap[bmcState] || this.normalizeStatus(bmcState),
                detail: bmcDetail,
                tone: bmcTone,
                icon: bmcState === 'testing'
                    ? 'bx bx-loader-alt bx-spin'
                    : bmcTone === 'rose' ? 'bx bx-x' : bmcTone === 'emerald' ? 'bx bx-check' : 'bx bx-plug',
            },
            {
                label: this.translateText('page.nodes.item.monitoring_status'),
                value: monitoringValueMap[monitoringState] || this.normalizeStatus(monitoringState),
                detail: monitoringDetail,
                tone: monitoringTone,
                icon: monitoringTone === 'emerald' ? 'bx bx-check'
                    : monitoringTone === 'rose' ? 'bx bx-x'
                    : monitoringTone === 'amber' ? 'bx bx-time-five' : 'bx bx-minus',
            },
        ];

        this.refreshHardwareSummaryView();

        this.summaryCards = [
            {
                label: this.translateText('page.nodes.item.summary_os'),
                value: String(this.item.summary_os || this.item.os_installed || this.item.image_os || '-'),
                icon: 'bx bx-chip',
            },
            {
                label: this.translateText('page.nodes.item.summary_bmc_power'),
                value: this.normalizeStatus(this.item.summary_power_status, '-'),
                icon: 'bx bx-desktop',
            },
            {
                label: this.translateText('page.nodes.item.summary_boot_device'),
                value: String(this.item.summary_boot_device || '-'),
                icon: 'bx bx-hdd',
            },
            {
                label: this.translateText('page.nodes.item.summary_boot_mode'),
                value: String(this.item.summary_boot_mode || this.item.boot_type || '-'),
                icon: 'bx bx-microchip',
            },
            {
                label: this.translateText('page.nodes.item.summary_last_scan'),
                value: String(this.item.last_bmc_check || this.item.last_bmc_scan || '-'),
                icon: 'bx bx-calendar',
            },
            {
                label: this.translateText('page.nodes.item.summary_registered'),
                value: String(this.item.registered_at || this.item.created || '-'),
                icon: 'bx bx-time-five',
            },
        ];
    }

    private refreshHardwareSummaryView() {
        const hardware = this.item?.hardware_summary || {};
        const compute = hardware.compute || {};
        const installedLabel = this.translateText('page.nodes.item.hardware.installed');
        const notInstalledLabel = this.translateText('page.nodes.item.hardware.not_installed');
        const notCollectedLabel = this.translateText('page.nodes.item.hardware.not_collected');
        const acceleratorCard = (key: string, labelKey: string, icon: string) => {
            const data = compute[key] || {};
            const installed = data.installed === true
                ? true
                : data.installed === false ? false : null;
            return {
                key,
                label: this.translateText(labelKey),
                value: String(data.value || (
                    installed === true ? installedLabel
                        : installed === false ? notInstalledLabel : notCollectedLabel
                )),
                detail: String(data.detail || ''),
                installed,
                status: installed === true
                    ? installedLabel
                    : installed === false ? notInstalledLabel : notCollectedLabel,
                icon,
            };
        };

        this.hardwareComputeCards = [
            {
                key: 'cpu',
                label: this.translateText('page.nodes.item.cpu'),
                value: String(compute.cpu?.value || notCollectedLabel),
                detail: String(compute.cpu?.detail || ''),
                installed: null,
                status: '',
                icon: 'bx bx-chip',
            },
            {
                key: 'memory',
                label: this.translateText('page.nodes.item.memory'),
                value: String(compute.memory?.value || notCollectedLabel),
                detail: String(compute.memory?.detail || ''),
                installed: null,
                status: '',
                icon: 'bx bx-memory-card',
            },
            acceleratorCard('gpu', 'page.nodes.item.hardware.gpu', 'bx bx-shape-square'),
            acceleratorCard('dpu', 'page.nodes.item.hardware.dpu', 'bx bx-chip'),
        ];

        const asset = hardware.asset || {};
        const manufacturer = String(asset.manufacturer || '').trim();
        this.hardwareAssetCards = [
            {
                key: 'system_uuid',
                label: this.translateText('page.nodes.item.hardware.system_uuid'),
                value: String(asset.system_uuid || notCollectedLabel),
                source: String(asset.system_uuid_source || '-'),
                copyable: Boolean(asset.system_uuid),
                icon: 'bx bx-id-card',
            },
            {
                key: 'board_serial',
                label: this.translateText('page.nodes.item.hardware.board_serial'),
                value: String(asset.board_serial || notCollectedLabel),
                source: String(asset.board_serial_source || '-'),
                copyable: Boolean(asset.board_serial),
                icon: 'bx bx-barcode',
            },
            {
                key: 'product_model',
                label: this.translateText('page.nodes.item.hardware.product_model'),
                value: String(asset.product_model || notCollectedLabel),
                source: String(asset.product_source || '-'),
                detail: this.translateText('page.nodes.item.hardware.manufacturer') + ': ' + (manufacturer || notCollectedLabel),
                copyable: false,
                icon: 'bx bx-server',
            },
        ];
    }

    public hardwareInventoryStatusLabel(): string {
        const status = String(this.item?.hardware_summary?.collection?.status || 'not-collected');
        const key = 'page.nodes.item.hardware.status.' + status;
        const translated = this.translateText(key);
        return translated === key ? this.normalizeStatus(status) : translated;
    }

    public hardwareInventoryStatusClass(): string {
        const status = String(this.item?.hardware_summary?.collection?.status || 'not-collected');
        if (status === 'collected') return 'bg-emerald-100 text-emerald-700';
        if (status === 'partial') return 'bg-amber-100 text-amber-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public async copyHardwareAsset(card: any) {
        const value = String(card?.value || '').trim();
        if (!card?.copyable || !value) return;

        let copied = false;
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                copied = true;
            }
        } catch (error) {
            copied = false;
        }

        if (!copied) {
            try {
                const textarea = document.createElement('textarea');
                textarea.value = value;
                textarea.setAttribute('readonly', 'true');
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                copied = document.execCommand('copy');
                document.body.removeChild(textarea);
            } catch (error) {
                copied = false;
            }
        }

        if (!copied) return;
        this.copiedHardwareKey = String(card.key || '');
        await this.service.render();
        setTimeout(async () => {
            if (this.componentDestroyed || this.copiedHardwareKey !== String(card.key || '')) return;
            this.copiedHardwareKey = '';
            await this.service.render();
        }, 1500);
    }

    public bmcTestResultClass(): string {
        return this.bmcTestResult?.ok
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-rose-200 bg-rose-50 text-rose-700';
    }

    public async testBmcConnection() {
        if (this.bmcTestLoading || !this.item?.bmc_ip) return;
        const requestId = ++this.bmcTestRequestId;
        this.bmcTestLoading = true;
        this.bmcTestResult = null;
        this.refreshSummaryView();
        await this.service.render();

        try {
            const requestData = {
                bmc_ip: this.item.bmc_ip,
                bmc_credential_id: this.selectedCredentialId,
            };
            const { code, data } = await wiz.call('bmc_test', {
                id: this.id,
                source: 'manual',
                data: JSON.stringify(requestData),
            });
            if (this.componentDestroyed || requestId !== this.bmcTestRequestId) return;
            this.bmcTestResult = code === 200
                ? data
                : {
                    ok: false,
                    message: this.translateText('page.nodes.item.bmc_test_failed'),
                    detail: data?.message || '',
                };
            if (this.bmcTestResult?.ok && this.bmcTestResult?.power) {
                this.item.summary_power_status = this.bmcTestResult.power;
            }
            if (this.bmcTestResult?.monitor_status) {
                const monitor = this.bmcTestResult.monitor_status;
                this.item.bmc_monitor_status = monitor.current_status || 'unknown';
                this.item.bmc_communication_status = monitor.communication_status || 'unknown';
                this.item.bmc_checking = Boolean(monitor.checking);
                this.item.bmc_failure_count = Number(monitor.failure_count || 0);
                this.item.last_bmc_check = monitor.last_checked || '';
                this.item.last_bmc_successful = monitor.last_successful || '';
                this.item.bmc_last_error_code = monitor.last_error_code || '';
                this.item.bmc_last_error = monitor.last_error || '';
                this.item.bmc_monitor_backend = monitor.backend || '';
            }
        } catch (error) {
            console.error(error);
            this.bmcTestResult = {
                ok: false,
                message: this.translateText('page.nodes.item.bmc_test_failed'),
                detail: String(error || ''),
            };
        } finally {
            if (this.componentDestroyed || requestId !== this.bmcTestRequestId) return;
            this.bmcTestLoading = false;
            this.refreshSummaryView();
            await this.service.render();
        }
    }

    public bmcMonitorStatusLabel(): string {
        const status = String(this.item?.bmc_monitor_status || 'unknown').toLowerCase();
        const labels: any = {
            power_on: '전원 ON',
            power_off: '전원 OFF',
            bmc_fault: 'BMC 불량',
            unknown: '확인 대기',
        };
        return this.item?.bmc_checking ? '확인 중' : (labels[status] || this.normalizeStatus(status));
    }

    public bmcMonitorStatusClass(): string {
        if (this.item?.bmc_checking) return 'bg-sky-100 text-sky-700';
        const status = String(this.item?.bmc_monitor_status || 'unknown').toLowerCase();
        if (status === 'power_on') return 'bg-emerald-100 text-emerald-700';
        if (status === 'power_off') return 'bg-slate-200 text-slate-700';
        if (status === 'bmc_fault') return 'bg-rose-100 text-rose-700';
        return 'bg-amber-100 text-amber-700';
    }

    public bmcErrorReasonLabel(code: any): string {
        const normalized = String(code || '').trim().toLowerCase();
        const labels: any = {
            credential_missing: 'Credential 미설정',
            authentication_failed: '인증 실패',
            timeout: '통신 시간 초과',
            connection_failed: '연결 실패',
            bmc_ip_missing: 'BMC IP 미설정',
            power_state_unknown: '전원 상태 해석 실패',
            bmc_api_failed: 'IPMI/Redfish 조회 실패',
            node_not_found: '노드 없음',
        };
        return labels[normalized] || (normalized ? this.normalizeStatus(normalized) : '-');
    }

    public async recheckBmcStatus() {
        if (this.bmcRecheckLoading || this.item?.bmc_checking) return;
        this.bmcRecheckLoading = true;
        this.bmcRecheckMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('bmc_recheck', { id: this.id });
            if (code !== 200) {
                this.bmcRecheckMessage = data?.message || 'BMC 상태 재확인을 예약하지 못했습니다.';
                return;
            }
            this.item.bmc_checking = true;
            this.item.bmc_connection_status = 'testing';
            this.bmcRecheckMessage = data?.message || 'BMC 상태 재확인을 작업 큐에 등록했습니다.';
            this.refreshSummaryView();
        } catch (error) {
            this.bmcRecheckMessage = String(error || 'BMC 상태 재확인을 예약하지 못했습니다.');
        } finally {
            this.bmcRecheckLoading = false;
            await this.service.render();
        }
    }

    private applyDefaultSshUser() {
        const suggestedUser = String(this.item?.default_login_user || 'root').trim() || 'root';
        this.sshUser = suggestedUser;
        if (!this.sshPassword) {
            this.sshPassword = 'kiera123';
        }
    }

    private async loadTabData() {
        if (!this.isTabEnabled(this.tab)) return;
        if (this.tab === 'network') {
            await this.loadNetworks();
        } else if (this.tab === 'storage') {
            await this.loadStorages();
        } else if (this.tab === 'devices') {
            await this.loadDevices();
        } else if (this.tab === 'history') {
            await this.loadDeployHistory();
        } else if (this.tab === 'timeline') {
            await this.loadTimeline();
        } else if (this.tab === 'zabbix') {
            await this.loadZabbixConfig();
        }
    }

    public selectTab(tab: string) {
        if (!this.isTabEnabled(tab)) return;
        this.service.href(`/kiera/nodes/${this.id}/${tab}`);
    }

    public isTabEnabled(tab: string) {
        if (tab === 'history') return this.logPolicy?.node_history !== false;
        if (tab === 'timeline') return this.logPolicy?.node_timeline !== false;
        return true;
    }

    public async save() {
        const editableFields = [
            'name', 'group_id', 'ip_address', 'rack', 'unit',
            'bmc_ip', 'bmc_credential_id',
        ];
        const payload: any = {};
        for (const field of editableFields) {
            payload[field] = this.item?.[field];
        }
        const { code } = await wiz.call("update", { id: this.id, data: JSON.stringify(payload) });
        if (code === 200) {
            alert(this.translate.instant('page.nodes.item.saved'));
            await this.load();
        }
    }

    public async deleteNode() {
        if (this.deleting) return;
        if (!confirm(this.translate.instant('page.nodes.item.confirm_delete'))) return;

        this.deleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("delete", { id: this.id });
            if (code === 200) {
                this.service.href('/kiera/nodes');
            } else {
                alert(data?.message || this.translate.instant('page.nodes.delete_failed'));
            }
        } catch (error) {
            console.error(error);
            alert(this.translate.instant('page.nodes.delete_failed'));
        } finally {
            this.deleting = false;
            await this.service.render();
        }
    }

    // =========================================================================
    // Network Interface
    // =========================================================================

    public async loadNetworks() {
        const { code, data } = await wiz.call("networks", { node_id: this.id });
        if (code === 200) {
            this.networkList = this.sortNetworks(data || []);
        }
    }

    private sortNetworks(rows: any[]): any[] {
        return [...rows].sort((left: any, right: any) => {
            const leftName = String(left?.name || '');
            const rightName = String(right?.name || '');
            const byName = leftName.localeCompare(rightName, undefined, { numeric: true, sensitivity: 'base' });
            if (byName !== 0) return byName;

            const leftMac = String(left?.mac_address || '');
            const rightMac = String(right?.mac_address || '');
            const byMac = leftMac.localeCompare(rightMac, undefined, { sensitivity: 'base' });
            if (byMac !== 0) return byMac;

            return Number(left?.id || 0) - Number(right?.id || 0);
        });
    }

    public addNetwork() {
        this.editingNetwork = {
            name: '', mac_address: '', ip_address: '',
            network_mode: 'dhcp', speed: '', type: 'ethernet', vlan_id: 0, is_primary: 0, oper_state: ''
        };
    }

    public editNetwork(net: any) {
        this.editingNetwork = { ...net, network_mode: this.resolveNetworkMode(net?.network_mode) };
    }

    public cancelNetwork() {
        this.editingNetwork = null;
    }

    public async saveNetwork() {
        if (!this.editingNetwork) return;
        this.editingNetwork.network_mode = this.resolveNetworkMode(this.editingNetwork.network_mode);
        const { code } = await wiz.call("network_save", {
            node_id: this.id, data: JSON.stringify(this.editingNetwork)
        });
        if (code === 409) {
            if (!confirm(this.duplicateIpConfirmMessage())) {
                await this.service.render();
                return;
            }
            const retry = await wiz.call("network_save", {
                node_id: this.id,
                force: 1,
                data: JSON.stringify(this.editingNetwork),
            });
            if (retry.code !== 200) {
                await this.service.render();
                return;
            }
            this.editingNetwork = null;
            await this.loadNetworks();
            await this.load();
            return;
        }
        if (code === 200) {
            this.editingNetwork = null;
            await this.loadNetworks();
            await this.load();
        }
        await this.service.render();
    }

    public resolveNetworkMode(value: any): string {
        const normalized = String(value || '').trim().toLowerCase();
        return this.networkModes.some((mode) => mode.value === normalized) ? normalized : 'static';
    }

    public networkModeLabel(value: any): string {
        const mode = this.networkModes.find((item) => item.value === this.resolveNetworkMode(value));
        return mode ? mode.label : 'Static';
    }

    public editingNetworkIsOpa(): boolean {
        const type = String(this.editingNetwork?.type || '').toLowerCase();
        const name = String(this.editingNetwork?.name || '').toLowerCase();
        return ['infiniband', 'ipoib', 'opa'].includes(type) || name.startsWith('ib') || name.startsWith('opa');
    }

    public editingNetworkModes(): Array<{ value: string; label: string; }> {
        return this.editingNetworkIsOpa()
            ? this.networkModes.filter((mode) => mode.value === 'static')
            : this.networkModes;
    }

    public onEditingNetworkTypeChanged() {
        if (this.editingNetworkIsOpa() && this.editingNetwork) {
            this.editingNetwork.network_mode = 'static';
        }
    }

    public opaStages(): any[] {
        return Array.isArray(this.item?.opa?.stages) ? this.item.opa.stages : [];
    }

    public opaStageStatusLabel(stage: any): string {
        const status = String(stage?.status || 'pending').toLowerCase();
        if (status.includes('complete') || status === 'ready') return '완료';
        if (status.includes('fail') || status.includes('error')) return '실패';
        if (status.includes('run') || status.includes('progress')) return '진행 중';
        if (status === 'not-applicable') return '대상 아님';
        return '대기';
    }

    public opaStageLightClass(stage: any): string {
        const status = String(stage?.status || 'pending').toLowerCase();
        if (status.includes('complete') || status === 'ready') return 'bg-emerald-500 ring-emerald-100';
        if (status.includes('fail') || status.includes('error')) return 'bg-rose-500 ring-rose-100';
        if (status.includes('run') || status.includes('progress')) return 'bg-blue-500 ring-blue-100 animate-pulse';
        if (status === 'not-applicable') return 'bg-slate-200 ring-slate-100';
        return 'bg-amber-300 ring-amber-100';
    }

    public opaElapsedLabel(stage: any): string {
        const seconds = Number(stage?.elapsed_seconds || 0);
        if (!Number.isFinite(seconds) || seconds <= 0) return '-';
        if (seconds < 60) return `${Math.round(seconds)}초`;
        const minutes = Math.floor(seconds / 60);
        const remainder = Math.round(seconds % 60);
        return remainder ? `${minutes}분 ${remainder}초` : `${minutes}분`;
    }

    public opaStageTitle(stage: any): string {
        const parts = [
            String(stage?.label || stage?.key || 'OPA'),
            this.opaStageStatusLabel(stage),
        ];
        const elapsed = this.opaElapsedLabel(stage);
        if (elapsed !== '-') parts.push(elapsed);
        const detail = String(stage?.failure_reason || stage?.message || '').trim();
        if (detail) parts.push(detail);
        return parts.join(' · ');
    }

    private duplicateIpConfirmMessage(): string {
        return this.translate.instant('page.nodes.item.confirm_duplicate_ip');
    }

    public async deleteNetwork(net: any) {
        if (!confirm(this.translate.instant('page.nodes.item.confirm_delete_network', { name: net.name }))) return;
        const { code } = await wiz.call("network_delete", { node_id: this.id, net_id: net.id });
        if (code === 200) {
            await this.loadNetworks();
        }
        await this.service.render();
    }

    // =========================================================================
    // Storage
    // =========================================================================

    public async loadStorages() {
        const { code, data } = await wiz.call("storages", { node_id: this.id });
        if (code === 200) {
            this.storageList = data;
        }
    }

    public addStorage() {
        this.editingStorage = {
            name: '', size: 0, mount_point: '', fs_type: '',
            model: '', serial: '', block_size: 0, dev_type: -1
        };
    }

    public editStorage(stor: any) {
        this.editingStorage = { ...stor };
    }

    public cancelStorage() {
        this.editingStorage = null;
    }

    public async saveStorage() {
        if (!this.editingStorage) return;
        const { code } = await wiz.call("storage_save", {
            node_id: this.id, data: JSON.stringify(this.editingStorage)
        });
        if (code === 200) {
            this.editingStorage = null;
            await this.loadStorages();
        }
        await this.service.render();
    }

    public async deleteStorage(stor: any) {
        if (!confirm(this.translate.instant('page.nodes.item.confirm_delete_storage', { name: stor.name }))) return;
        const { code } = await wiz.call("storage_delete", { node_id: this.id, stor_id: stor.id });
        if (code === 200) {
            await this.loadStorages();
        }
        await this.service.render();
    }

    public async loadDevices() {
        const { code, data } = await wiz.call("devices", { node_id: this.id });
        if (code === 200) {
            this.deviceList = data;
        }
    }

    public async loadDeployHistory() {
        const { code, data } = await wiz.call("deploy_history", {
            node_id: this.id,
            page: this.historyPage,
            dump: this.historyPageSize,
            sort_field: this.historySortField,
            sort_dir: this.historySortDir,
            search_text: this.historySearchText,
            status_filter: this.historyStatusFilter,
            method_filter: this.historyMethodFilter,
        });
        if (code === 200) {
            this.deployHistory = data.rows || [];
            this.historyTotalCount = Number(data.total || 0);
            this.historyStatusOptions = data.filters?.statuses || ['all'];
            this.historyMethodOptions = data.filters?.methods || ['all'];
        }
        await this.service.render();
    }

    public async applyHistoryFilters() {
        this.historyPage = 1;
        await this.loadDeployHistory();
    }

    public async clearHistoryFilters() {
        this.historySearchText = '';
        this.historyStatusFilter = 'all';
        this.historyMethodFilter = 'all';
        this.historyPage = 1;
        await this.loadDeployHistory();
    }

    public getSortedHistory(): any[] {
        return [...this.deployHistory];
    }

    public async sortHistory(field: string) {
        if (this.historySortField === field) {
            this.historySortDir = this.historySortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.historySortField = field;
            this.historySortDir = 'desc';
        }
        this.historyPage = 1;
        await this.loadDeployHistory();
    }

    public getPagedHistory(): any[] {
        return this.getSortedHistory();
    }

    public historyHasDetail(row: any): boolean {
        const log = row?.log_data || {};
        return Boolean(
            log.source_label ||
            log.origin_label ||
            log.execution_scope ||
            log.changed_summary ||
            log.changed_fields ||
            log.changes ||
            log.relay_summary ||
            log.deliverer_addresses ||
            log.cluster_name ||
            log.cluster_id ||
            log.operation_id ||
            log.message ||
            log.result_summary ||
            (row?.status === 'failed' && log.error)
        );
    }

    private valueList(value: any): string[] {
        if (Array.isArray(value)) return value.map((item) => String(item || '').trim()).filter((item) => item);
        const text = String(value || '').trim();
        return text ? [text] : [];
    }

    private rowLog(row: any): any {
        return row?.log_data || row || {};
    }

    private executionScope(item: any): string {
        const data = this.rowLog(item);
        const scope = String(data?.execution_scope || '').trim().toLowerCase();
        if (scope) return scope;
        const hasClusterContext = Boolean(data?.cluster_id || data?.cluster_name || data?.cluster_source);
        const hasRelayContext = Boolean(data?.relay_summary || data?.relay_job_id || data?.relay_stage || data?.relay_group_id);
        if (hasClusterContext && hasRelayContext) return 'cluster-relay';
        if (data?.cluster_id || data?.cluster_name || data?.cluster_source) return 'cluster';
        if (data?.relay_summary || data?.relay_job_id || data?.relay_stage || data?.relay_group_id) return 'relay';
        return '';
    }

    public getHistoryScopeLabel(row: any): string {
        const log = this.rowLog(row);
        const scope = this.executionScope(row);
        const source = String(log.source_label || log.origin_label || '').trim();
        const name = String(log.scope_name || log.cluster_name || (log.cluster_id ? `#${log.cluster_id}` : '') || log.relay_summary || '').trim();
        if (scope === 'cluster-relay') return name ? `Cluster Relay: ${name}` : 'Cluster Relay';
        if (scope === 'cluster') return name ? `Cluster: ${name}` : 'Cluster';
        if (scope === 'relay') return name ? `Relay: ${name}` : 'Relay';
        if (source) return name ? `${source}: ${name}` : source;
        return '';
    }

    public getHistoryScopeClass(row: any): string {
        const scope = this.executionScope(row);
        if (scope === 'cluster-relay') return 'bg-violet-100 text-violet-700 border-violet-200';
        if (scope === 'cluster') return 'bg-orange-100 text-orange-700 border-orange-200';
        if (scope === 'relay') return 'bg-indigo-100 text-indigo-700 border-indigo-200';
        if (scope === 'node') return 'bg-zinc-100 text-zinc-700 border-zinc-200';
        return 'bg-sky-100 text-sky-700 border-sky-200';
    }

    public getRelaySummaryLabel(row: any): string {
        return this.executionScope(row) === 'cluster-relay' ? 'Relay Server' : 'Relay';
    }

    public getHistoryChangedFields(row: any): string {
        const log = this.rowLog(row);
        const summary = String(log.changed_summary || '').trim();
        if (summary) return summary;
        const fields = this.valueList(log.changed_fields);
        return fields.join(', ');
    }

    public getHistoryChangePreview(row: any): string {
        const changes = this.rowLog(row)?.changes;
        if (!Array.isArray(changes)) return '';
        return changes.slice(0, 3).map((item: any) => {
            const label = String(item?.label || item?.field || '').trim();
            const before = String(item?.before ?? '').trim() || '-';
            const after = String(item?.after ?? '').trim() || '-';
            return label ? `${label}: ${before} -> ${after}` : '';
        }).filter((item: string) => item).join('; ');
    }

    public historyTotalPages(): number {
        return Math.max(1, Math.ceil(this.historyTotalCount / this.historyPageSize));
    }

    public historyPageRange(): number[] {
        return this.buildPageRange(this.historyPage, this.historyTotalPages());
    }

    public async setHistoryPage(page: number) {
        this.historyPage = page;
        await this.loadDeployHistory();
    }

    public async setHistoryPageSize(size: number) {
        this.historyPageSize = Number(size);
        this.historyPage = 1;
        await this.loadDeployHistory();
    }

    public getPhysicalDisks(): any[] {
        return this.storageList.filter((s: any) => s.dev_type !== undefined && s.dev_type !== -1 && !s.mount_point);
    }

    public getPartitions(): any[] {
        return this.storageList.filter((s: any) => s.dev_type === -1 || (s.mount_point && s.mount_point !== ''));
    }

    public formatSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let i = 0;
        let size = bytes;
        while (size >= 1024 && i < units.length - 1) {
            size /= 1024;
            i++;
        }
        return `${size.toFixed(1)} ${units[i]}`;
    }

    public getDevTypeLabel(devType: number): string {
        if (devType === 0) return 'HDD/SSD';
        if (devType === -1) return '-';
        return `Type ${devType}`;
    }

    public async setBootDevice(stor: any) {
        const { code } = await wiz.call("set_boot_device", { node_id: this.id, stor_id: stor.id });
        if (code === 200) {
            await this.loadStorages();
        }
        await this.service.render();
    }

    public addPhysicalDisk() {
        this.editingStorage = {
            name: '', size: 0, mount_point: '', fs_type: '',
            model: '', serial: '', block_size: 0, dev_type: 0, boot: 0
        };
    }

    // =========================================================================
    // Timeline
    // =========================================================================

    public async loadTimeline() {
        const { code, data } = await wiz.call("timeline", {
            node_id: this.id,
            page: this.timelinePage,
            dump: this.timelinePageSize,
            filter: this.timelineFilter,
            range: this.timelineRange,
            search_text: this.timelineSearchText,
            status_filter: this.timelineStatusFilter,
        });
        if (code === 200) {
            this.timelineEvents = data.events || [];
            this.timelineSummary = data.summary || {};
            this.timelineChart = data.chart || [];
            this.timelineTotalCount = Number(data.total || 0);
            this.timelineStatusOptions = data.filters?.statuses || ['all'];
        }
        await this.service.render();
    }

    public async applyTimelineFilters() {
        this.timelinePage = 1;
        await this.loadTimeline();
    }

    public async clearTimelineFilters() {
        this.timelineSearchText = '';
        this.timelineStatusFilter = 'all';
        this.timelinePage = 1;
        await this.loadTimeline();
    }

    public getFilteredTimeline(): any[] {
        return [...this.timelineEvents];
    }

    public async setTimelineFilter(filter: string) {
        this.timelineFilter = filter;
        this.timelinePage = 1;
        await this.loadTimeline();
    }

    public async setTimelineRange(range: string) {
        this.timelineRange = range;
        this.timelinePage = 1;
        await this.loadTimeline();
    }

    public getPagedTimeline(): any[] {
        return this.getFilteredTimeline();
    }

    public getPagedTimelineRows(): any[] {
        const events = this.getPagedTimeline();
        const rows: any[] = [];
        let index = 0;

        while (index < events.length) {
            const event = events[index] || {};
            if (event.kind === 'pxe-group' || event.kind === 'sol-group') {
                rows.push(event);
                index++;
                continue;
            }
            if (this.isTimelinePxeBoot(event)) {
                const groupEvents = [event];
                let cursor = index + 1;

                while (cursor < events.length && this.canFoldPxeBoot(groupEvents[groupEvents.length - 1], events[cursor])) {
                    groupEvents.push(events[cursor]);
                    cursor++;
                }

                if (groupEvents.length > 1) {
                    rows.push(this.buildPxeBootRow(groupEvents, index));
                } else {
                    rows.push(this.buildTimelineEventRow(event, index));
                }
                index = cursor;
                continue;
            }

            rows.push(this.buildTimelineEventRow(event, index));
            index++;
        }

        return rows;
    }

    private buildTimelineEventRow(event: any, index: number): any {
        return {
            kind: 'event',
            key: this.timelineEventKey(event, index),
            event,
            timestamp: event?.timestamp || '',
            status: event?.status || '',
        };
    }

    private buildPxeBootRow(events: any[], index: number): any {
        const first = events[0] || {};
        const last = events[events.length - 1] || {};
        return {
            kind: 'pxe-group',
            key: `pxe:${this.timelinePxeFingerprint(first)}:${first.timestamp || ''}:${last.timestamp || ''}:${events.length}:${index}`,
            type: 'pxe-boot',
            events,
            action: this.timelineAction(first),
            status: this.timelineGroupStatus(events.map((event: any) => event?.status)),
            timestamp: first.timestamp || '',
            lastTimestamp: last.timestamp || '',
            mac: first.mac || '',
            subnet: first.subnet || '',
            pxe_next_server_ip: first.pxe_next_server_ip || '',
            boot_metadata_server_ip: first.boot_metadata_server_ip || '',
            rootfs_primary_ip: first.rootfs_primary_ip || '',
        };
    }

    private timelineEventKey(event: any, index: number): string {
        const identity = event?.idempotency_key || event?.outbox_id || event?.task_id || event?.deploy_id || event?.related_id || event?.timestamp || index;
        return `${event?.type || 'event'}:${identity}:${index}`;
    }

    private isTimelinePxeBoot(event: any): boolean {
        return String(event?.type || '') === 'pxe-boot';
    }

    private timelineAction(event: any): string {
        const direct = String(event?.action || event?.stage || '').trim();
        if (direct) return direct;
        const message = String(event?.message || '');
        const match = message.match(/PXE Boot:\s*([^(]+)/i);
        return match ? match[1].trim() : '';
    }

    private timelinePxeFingerprint(event: any): string {
        const parts = [
            String(event?.mac || '').trim().toLowerCase(),
            String(event?.subnet || '').trim().toLowerCase(),
            String(event?.pxe_next_server_ip || event?.boot_metadata_server_ip || '').trim(),
            String(this.timelineAction(event) || '').trim().toLowerCase(),
        ].filter((part) => part);
        return parts.join('|') || 'node';
    }

    private canFoldPxeBoot(previous: any, next: any): boolean {
        if (!this.isTimelinePxeBoot(next)) return false;
        if (this.timelinePxeFingerprint(previous) !== this.timelinePxeFingerprint(next)) return false;

        const previousTime = this.parseTimestamp(previous?.timestamp);
        const nextTime = this.parseTimestamp(next?.timestamp);
        if (!previousTime || !nextTime) return true;

        return Math.abs(previousTime.getTime() - nextTime.getTime()) <= 10 * 60 * 1000;
    }

    private timelineGroupStatus(statuses: any[]): string {
        const normalized = statuses.map((status) => String(status || '').trim().toLowerCase()).filter((status) => status);
        if (normalized.some((status) => ['error', 'failed', 'failure'].includes(status))) return 'failed';
        const active = normalized.find((status) => ['booting', 'running', 'deploying', 'waiting-serial', 'receiving-serial', 'sol-activating', 'sol-operational'].includes(status));
        if (active) return active;
        const terminal = normalized.find((status) => ['disconnected', 'closed', 'configured', 'completed', 'success', 'deployed'].includes(status));
        if (terminal) return terminal;
        return normalized[0] || 'info';
    }

    public isTimelineGroupExpanded(key: string): boolean {
        return this.timelineExpandedGroups[key] === true;
    }

    public toggleTimelineGroup(key: string) {
        this.timelineExpandedGroups[key] = !this.timelineExpandedGroups[key];
    }

    public timelineTotalPages(): number {
        return Math.max(1, Math.ceil(this.timelineTotalCount / this.timelinePageSize));
    }

    public timelinePageRange(): number[] {
        const total = this.timelineTotalPages();
        const current = Math.min(total, Math.max(1, Number(this.timelinePage || 1)));
        const start = Math.floor((current - 1) / this.timelinePageWindowSize) * this.timelinePageWindowSize + 1;
        const end = Math.min(total, start + this.timelinePageWindowSize - 1);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async setTimelinePage(page: number) {
        const requested = Number(page || 1);
        const safePage = Number.isFinite(requested) ? requested : 1;
        this.timelinePage = Math.min(this.timelineTotalPages(), Math.max(1, safePage));
        await this.loadTimeline();
    }

    public async setTimelinePageSize(size: number) {
        this.timelinePageSize = Number(size);
        this.timelinePage = 1;
        await this.loadTimeline();
    }

    public buildPageRange(current: number, total: number): number[] {
        const delta = 2;
        let start = Math.max(1, current - delta);
        let end = Math.min(total, current + delta);
        if (end - start < 4) {
            if (start === 1) end = Math.min(total, start + 4);
            else start = Math.max(1, end - 4);
        }
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public openRelay(relayGroupId: string) {
        if (!relayGroupId) return;
        this.service.href(`/kiera/relay/${relayGroupId}`);
    }

    public buildTimelineChart() {
        const events = this.timelineEvents.filter((e: any) => !e.type.endsWith('-log'));
        const days = this.timelineRange === 'all' ? 365 : parseInt(this.timelineRange);
        const now = new Date();
        const buckets: any = {};

        // 날짜 버킷 초기화
        for (let i = days - 1; i >= 0; i--) {
            const d = new Date(now);
            d.setDate(d.getDate() - i);
            const key = d.toISOString().slice(0, 10);
            buckets[key] = { label: key.slice(5), deploy: 0, commission: 0, pxe: 0, total: 0 };
        }

        // 이벤트 집계
        for (const ev of events) {
            const dateKey = (ev.timestamp || '').slice(0, 10);
            if (buckets[dateKey]) {
                buckets[dateKey].total++;
                if (ev.type === 'deploy') buckets[dateKey].deploy++;
                else if (ev.type === 'commission') buckets[dateKey].commission++;
                else if (ev.type === 'pxe-boot') buckets[dateKey].pxe++;
            }
        }

        this.timelineChart = Object.values(buckets);
    }

    public getChartMax(): number {
        if (!this.timelineChart.length) return 1;
        return Math.max(1, ...this.timelineChart.map((b: any) => b.total));
    }

    public getChartMid(): number {
        return Math.round(this.getChartMax() / 2);
    }

    public getChartMidLabel(): string {
        if (!this.timelineChart.length) return '';
        const mid = Math.floor(this.timelineChart.length / 2);
        return this.timelineChart[mid]?.label || '';
    }

    public getChartPath(field: string): string {
        if (!this.timelineChart.length) return '';
        const max = this.getChartMax();
        const h = 100; // SVG height
        const w = 100; // SVG width %
        const step = this.timelineChart.length > 1 ? w / (this.timelineChart.length - 1) : w;
        return this.timelineChart.map((b: any, i: number) => {
            const x = this.timelineChart.length > 1 ? (i * step) : (w / 2);
            const y = h - (b[field] / max * h);
            return `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)}`;
        }).join(' ');
    }

    public getChartAreaPath(field: string): string {
        const linePath = this.getChartPath(field);
        if (!linePath) return '';
        const max = this.getChartMax();
        const h = 100;
        const w = 100;
        const step = this.timelineChart.length > 1 ? w / (this.timelineChart.length - 1) : w;
        const lastX = this.timelineChart.length > 1 ? ((this.timelineChart.length - 1) * step).toFixed(2) : (w / 2).toFixed(2);
        const firstX = this.timelineChart.length > 1 ? '0.00' : (w / 2).toFixed(2);
        return `${linePath} L${lastX},${h} L${firstX},${h} Z`;
    }

    public showChartLabel(index: number): boolean {
        const len = this.timelineChart.length;
        if (len <= 14) return true;
        const interval = Math.ceil(len / 14);
        return index % interval === 0;
    }

    public getTimelineIcon(type: string): string {
        switch (type) {
            case 'operation-task': return 'bx bx-play-circle text-sky-500';
            case 'node-change': return 'bx bx-edit-alt text-zinc-500';
            case 'pxe-transport': return 'bx bx-transfer text-teal-500';
            case 'deploy': return 'bx bx-cloud-download text-indigo-500';
            case 'commission': return 'bx bx-search-alt text-purple-500';
            case 'backup': return 'bx bx-archive text-amber-500';
            case 'pxe-boot': return 'bx bx-power-off text-green-500';
            case 'sol-session': return 'bx bx-terminal text-emerald-500';
            case 'deploy-log': return 'bx bx-chevron-right text-zinc-400';
            case 'commission-log': return 'bx bx-chevron-right text-zinc-400';
            case 'backup-log': return 'bx bx-chevron-right text-zinc-400';
            default: return 'bx bx-circle text-zinc-300';
        }
    }

    public getTimelineRowIcon(row: any): string {
        if (row?.kind === 'pxe-group') return 'bx bx-power-off text-emerald-600';
        const action = String(row?.event?.action || row?.action || '').toLowerCase();
        if (action.startsWith('opa-') || action.startsWith('relay-opa-')) return 'bx bx-network-chart text-teal-500';
        return this.getTimelineIcon(row?.event?.type || row?.type || '');
    }

    public getTimelineMarkerClass(row: any): string {
        const type = row?.kind === 'pxe-group' ? 'pxe-boot' : row?.kind === 'sol-group' ? 'sol-session' : String(row?.event?.type || '');
        const status = String(row?.status || row?.event?.status || '').toLowerCase();
        const scope = this.executionScope(row?.event || row);
        if (status === 'failed' || status === 'error') return 'bg-red-50 border-red-200';
        if (scope === 'cluster-relay') return 'bg-violet-50 border-violet-200';
        if (scope === 'cluster') return 'bg-orange-50 border-orange-200';
        if (scope === 'relay') return 'bg-indigo-50 border-indigo-200';
        if (type === 'node-change') return 'bg-zinc-50 border-zinc-200';
        if (type === 'operation-task') return 'bg-sky-50 border-sky-200';
        if (type === 'pxe-transport') return 'bg-teal-50 border-teal-200';
        if (type === 'deploy') return 'bg-indigo-50 border-indigo-200';
        if (type === 'commission') return 'bg-purple-50 border-purple-200';
        if (type === 'backup') return 'bg-amber-50 border-amber-200';
        if (type === 'pxe-boot') return 'bg-emerald-50 border-emerald-200';
        if (type === 'sol-session') return 'bg-cyan-50 border-cyan-200';
        if (type.endsWith('-log')) return 'bg-white border-zinc-200';
        return 'bg-zinc-50 border-zinc-200';
    }

    public getTimelineContentClass(row: any): string {
        const type = row?.kind === 'pxe-group' ? 'pxe-boot' : row?.kind === 'sol-group' ? 'sol-session' : String(row?.event?.type || '');
        const scope = this.executionScope(row?.event || row);
        if (row?.kind === 'pxe-group') return 'bg-emerald-50/60 border-emerald-100';
        if (row?.kind === 'sol-group') return 'bg-cyan-50/60 border-cyan-100';
        if (scope === 'cluster-relay') return 'bg-violet-50/60 border-violet-100';
        if (scope === 'cluster') return 'bg-orange-50/60 border-orange-100';
        if (scope === 'relay') return 'bg-indigo-50/60 border-indigo-100';
        if (type === 'node-change') return 'bg-zinc-50 border-zinc-100';
        if (type === 'operation-task') return 'bg-sky-50/60 border-sky-100';
        if (type === 'pxe-transport') return 'bg-teal-50/60 border-teal-100';
        if (type.endsWith('-log')) return 'ml-2 bg-white border-zinc-50';
        return 'bg-zinc-50 border-zinc-100';
    }

    public getTimelineStageLabel(row: any): string {
        if (row?.kind === 'pxe-group') return 'PXE Boot';
        if (row?.kind === 'sol-group') return 'SOL';
        const event = row?.event || {};
        const type = String(event.type || '');
        const source = String(event.source || '');
        const action = String(event.action || row?.action || '').toLowerCase().replace(/^relay-/, '');
        const scope = this.executionScope(event);
        if (action === 'opa-prepare') return 'OPA 준비';
        if (action === 'opa-network') return 'OPA 연결';
        if (action === 'opa-rootfs') return 'RootFS 수신';
        if (type === 'node-change') return 'Node Info';
        if (type === 'operation-task' && scope === 'cluster-relay') return 'Cluster Relay Command';
        if (type === 'operation-task' && scope === 'cluster') return 'Cluster Command';
        if (type === 'operation-task' && scope === 'relay') return 'Relay Command';
        if (type === 'operation-task') return 'Action';
        if (type === 'pxe-transport' || (source === 'pxe_boot_log' && type === 'pxe-transport')) return 'PXE/TFTP configured';
        if (type === 'deploy' && scope === 'cluster-relay') return 'Cluster Relay Deploy';
        if (type === 'deploy') return 'Deploy command';
        if (type === 'commission') return 'Commission';
        if (type === 'backup') return 'Backup';
        if (type === 'pxe-boot') return 'PXE Boot';
        if (type === 'sol-session') return 'SOL';
        if (type.endsWith('-log')) return 'Log';
        return 'Action';
    }

    public getTimelineStageBadge(row: any): string {
        const type = row?.kind === 'pxe-group' ? 'pxe-boot' : row?.kind === 'sol-group' ? 'sol-session' : String(row?.event?.type || '');
        const action = String(row?.event?.action || row?.action || '').toLowerCase();
        const scope = this.executionScope(row?.event || row);
        if (action.startsWith('opa-') || action.startsWith('relay-opa-')) return 'bg-teal-100 text-teal-700';
        if (scope === 'cluster-relay') return 'bg-violet-100 text-violet-700';
        if (scope === 'cluster') return 'bg-orange-100 text-orange-700';
        if (scope === 'relay') return 'bg-indigo-100 text-indigo-700';
        if (type === 'node-change') return 'bg-zinc-100 text-zinc-700';
        if (type === 'operation-task') return 'bg-sky-100 text-sky-700';
        if (type === 'pxe-transport') return 'bg-teal-100 text-teal-700';
        if (type === 'deploy') return 'bg-indigo-100 text-indigo-700';
        if (type === 'commission') return 'bg-purple-100 text-purple-700';
        if (type === 'backup') return 'bg-amber-100 text-amber-700';
        if (type === 'pxe-boot') return 'bg-emerald-100 text-emerald-700';
        if (type === 'sol-session') return 'bg-cyan-100 text-cyan-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public getTimelineScopeLabel(event: any): string {
        const scope = this.executionScope(event);
        const data = this.rowLog(event);
        const name = String(data.scope_name || data.cluster_name || (data.cluster_id ? `#${data.cluster_id}` : '') || data.relay_summary || data.relay_stage || '').trim();
        if (scope === 'cluster-relay') return name ? `Cluster Relay ${name}` : 'Cluster Relay';
        if (scope === 'cluster') return name ? `Cluster ${name}` : 'Cluster';
        if (scope === 'relay') return name ? `Relay ${name}` : 'Relay';
        if (String(data.source_label || '').trim()) return String(data.source_label).trim();
        return '';
    }

    public getTimelineScopeBadge(event: any): string {
        const scope = this.executionScope(event);
        if (scope === 'cluster-relay') return 'bg-violet-100 text-violet-700 border-violet-200';
        if (scope === 'cluster') return 'bg-orange-100 text-orange-700 border-orange-200';
        if (scope === 'relay') return 'bg-indigo-100 text-indigo-700 border-indigo-200';
        return 'bg-zinc-100 text-zinc-700 border-zinc-200';
    }

    public getTimelineChangedFields(event: any): string {
        return this.getHistoryChangedFields(event);
    }

    public getTimelineChangePreview(event: any): string {
        return this.getHistoryChangePreview(event);
    }

    public getTimelineGroupTitle(row: any): string {
        if (row?.kind === 'sol-group') return 'SOL Session';
        const action = String(row?.action || '').trim();
        return action ? `PXE Boot: ${action}` : 'PXE Boot events';
    }

    public getTimelineGroupToggleLabel(row: any): string {
        const count = Number(row?.events?.length || 0);
        const expanded = this.isTimelineGroupExpanded(row?.key || '');
        if (row?.kind === 'sol-group') return expanded ? 'Hide SOL states' : `Show ${count} SOL states`;
        return expanded ? 'Hide PXE boots' : `Show ${count} PXE boots`;
    }

    public getTimelineSessionLabel(row: any): string {
        const sessionId = String(row?.session_id || '').trim();
        if (!sessionId) return '';
        if (sessionId.length <= 24) return sessionId;
        return `${sessionId.slice(0, 10)}...${sessionId.slice(-8)}`;
    }

    public getTimelineGroupSummary(row: any): string {
        const count = Number(row?.events?.length || 0);
        const latest = String(row?.timestamp || '').trim();
        const earliest = String(row?.lastTimestamp || '').trim();
        const range = latest && earliest && latest !== earliest ? `${earliest} - ${latest}` : latest;
        return range ? `${count} events · ${range}` : `${count} events`;
    }

    public showTimelineCompleted(event: any): boolean {
        const type = String(event?.type || '');
        const completed = String(event?.completed || '').trim();
        return ['deploy', 'commission', 'backup'].includes(type) && Boolean(completed);
    }

    public getTimelineCompletedLabel(event: any): string {
        const type = String(event?.type || '');
        const scope = this.executionScope(event);
        if (type === 'deploy' && scope === 'cluster-relay') return 'Cluster relay deploy completed';
        if (type === 'commission') return 'Commission completed';
        if (type === 'backup') return 'Backup completed';
        return 'Deploy completed';
    }

    public getTimelineStatusBadge(status: string): string {
        const normalized = String(status || '').toLowerCase();
        if (normalized.includes('fail') || normalized.includes('error')) return 'bg-red-100 text-red-700';
        if (normalized.includes('complete') || normalized.includes('success')) return 'bg-green-100 text-green-700';
        if (normalized.includes('running') || normalized.includes('progress')) return 'bg-blue-100 text-blue-700';
        switch (status) {
            case 'success': case 'completed': case 'deployed': return 'bg-green-100 text-green-700';
            case 'configured': return 'bg-teal-100 text-teal-700';
            case 'disconnected': case 'closed': return 'bg-zinc-100 text-zinc-600';
            case 'pending': case 'booting': case 'waiting-serial': return 'bg-amber-100 text-amber-700';
            case 'deploying': case 'running': case 'socket-connected': case 'sol-activating': case 'sol-operational': return 'bg-blue-100 text-blue-700';
            case 'receiving-serial': return 'bg-emerald-100 text-emerald-700';
            case 'error': case 'failed': return 'bg-red-100 text-red-700';
            case 'info': return 'bg-zinc-100 text-zinc-600';
            case 'warning': return 'bg-amber-100 text-amber-700';
            default: return 'bg-zinc-100 text-zinc-600';
        }
    }

    public optionLabel(value: string): string {
        if (String(value || '').trim() === 'all') {
            return this.translate.instant('common.all');
        }
        return String(value || '').trim() || '-';
    }

    // =========================================================================
    // Zabbix
    // =========================================================================

    public async loadZabbixConfig() {
        if (this.zabbixConfigLoaded) return;
        const { code, data } = await wiz.call("zabbix_config");
        if (code === 200 && data) {
            if (data.server_ip && !this.zabbixServerIp) {
                this.zabbixServerIp = data.server_ip;
            }
        }
        this.zabbixConfigLoaded = true;
        await this.service.render();
        // 자동으로 상태 체크
        if (this.item?.ip_address && this.sshPassword) {
            await this.checkZabbixStatus();
        }
    }

    public async checkZabbixStatus() {
        if (!this.sshPassword) {
            alert('SSH Password is required');
            return;
        }
        this.zabbixLoading = true;
        this.zabbixInstallLog = '';
        await this.service.render();
        const { code, data } = await wiz.call("zabbix_status", {
            node_id: this.id, ssh_user: this.sshUser, ssh_password: this.sshPassword
        });
        this.zabbixLoading = false;
        if (code === 200) {
            this.zabbixStatus = data;
        } else {
            this.zabbixStatus = null;
            alert(data?.message || 'Failed to check status');
        }
        await this.service.render();
    }

    public async installZabbixAgent() {
        if (!this.sshPassword) { alert('SSH Password is required'); return; }
        if (!this.zabbixServerIp) { alert('Zabbix Server IP is required'); return; }
        if (!confirm('Install Zabbix Agent on this node?')) return;
        this.zabbixLoading = true;
        this.zabbixInstallLog = 'Installing Zabbix Agent...';
        await this.service.render();
        const { code, data } = await wiz.call("zabbix_install_agent", {
            node_id: this.id, ssh_user: this.sshUser, ssh_password: this.sshPassword,
            zabbix_server: this.zabbixServerIp
        });
        this.zabbixLoading = false;
        if (code === 200) {
            this.zabbixInstallLog = data || 'Installation completed';
            await this.checkZabbixStatus();
        } else {
            this.zabbixInstallLog = `Error: ${data?.message || 'Installation failed'}`;
        }
        await this.service.render();
    }

    public async installZabbixProxy() {
        if (!this.sshPassword) { alert('SSH Password is required'); return; }
        if (!this.zabbixServerIp) { alert('Zabbix Server IP is required'); return; }
        if (!confirm('Install Zabbix Proxy on this node?')) return;
        this.zabbixLoading = true;
        this.zabbixInstallLog = 'Installing Zabbix Proxy (this may take a few minutes)...';
        await this.service.render();
        const { code, data } = await wiz.call("zabbix_install_proxy", {
            node_id: this.id, ssh_user: this.sshUser, ssh_password: this.sshPassword,
            zabbix_server: this.zabbixServerIp, proxy_name: this.proxyName || this.item?.name || ''
        });
        this.zabbixLoading = false;
        if (code === 200) {
            this.zabbixInstallLog = data || 'Installation completed';
            await this.checkZabbixStatus();
        } else {
            this.zabbixInstallLog = `Error: ${data?.message || 'Installation failed'}`;
        }
        await this.service.render();
    }
    public canManageResourceUsers() { return ['admin', 'superadmin'].includes(String(this.service.auth.session?.role || '').toLowerCase()); }
}

export default PageKieraNodesItemComponent;
